import Photo from '../src/Photo/index.tsx';
export default Photo;
